@if (shouldShow) {
  <div
    class="env-badge"
    [class.env-badge-dev]="envName === 'dev'"
    [class.env-badge-test]="envName === 'test'"
    [attr.title]="envLabel + ' environment'"
    [attr.aria-label]="envLabel + ' environment'"
  >
    <fa-icon class="env-badge__icon" [icon]="warningIcon" [fixedWidth]="true" [attr.aria-hidden]="'true'"></fa-icon>
    <span class="env-badge__label">{{ envLabel }}</span>
  </div>
}
